import { Component, ViewChild, Renderer } from '@angular/core';
import { NavController, NavParams, Content } from 'ionic-angular';
//Pages
import { AtividadePage } from '../atividade/atividade';
//Components
import { CustomAlert } from '../../components/custom-alert.component';
import { RefreshInfoComponent } from '../../components/refresh-info/refresh-info.component';
//Providers
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { CongressoProvider } from '../../providers/congresso-provider';
import { UserProvider } from '../../providers/user-provider';
import { CalendarProvider } from '../../providers/calendar-provider';
import { AuthProvider } from '../../providers/auth-provider';
import { StorageProvider } from '../../providers/storage-provider';
//Models
import { User } from '../../models/user.model';
import { Program } from '../../models/program.model';
import { DayProgram } from '../../models/day-program.model';
import { Congresso } from '../../models/congresso.model';
import { Filter } from '../../models/filter.model';
import { Activity } from '../../models/activity.model';
import { Lecturer } from '../../models/lecturer.model';
import { AreaProgram } from '../../models/area.program.model';

@Component({
  selector: 'page-aulas',
  templateUrl: 'aulas.html'
})
export class AulasPage {

  @ViewChild(Content) content: Content;

  private days: string;
  private didSelect: boolean;
  private user: User;
  private filter: Filter;
  private activitiesFiltered: Array<Activity>;
  public activities: Array<Activity>;
  private program: Program;
  private congresso: Congresso;
  private congressos: Array<Congresso>;
  private areas: Array<string> = ["Ginecologia", "Obstetrícia", "Geral"];
  private area: string;
  public paramArea = undefined;

  private salas: Array<string>;
  private horarios: Array<string>;
  private tipos: Array<string>;
  private palestrantes: Array<string>;
  private palestrantesSearch: Array<string>;
  private radioSelected: boolean;
  public isCurrent: boolean;
  private showList: boolean;
  private loaded: boolean;
  private activitiesInscIds: number[];
  private atividadesAssistidasIds: number[];
  private selectOptions = { mode: 'ios' };
  private lastRefreshDate: string;
  private LM: string = "LM";
  private SP: string = "SP";
  private CPO: string = "CPO";
  private CPG: string = "CPG";
  private ABT: string = "ABT";
  private ECR: string = "ECR";

  constructor(public navCtrl: NavController,
    private alert: CustomAlert,
    private refreshInfo: RefreshInfoComponent,
    private navParams: NavParams,
    private configProvider: ConfigProvider,
    private userProvider: UserProvider,
    public utilProvider: UtilProvider,
    private renderer: Renderer,
    private congressoProvider: CongressoProvider,
    private auth: AuthProvider,
    private calendarProvider: CalendarProvider,
    private storageProvider: StorageProvider) {

    this.filter = new Filter();
    this.filter.palestrante = '';
    if (JSON.parse(localStorage.getItem('filter')))
      this.filter = JSON.parse(localStorage.getItem('filter')) as Filter;
    this.program = new Program();
    this.program.Days = new Array<DayProgram>();
    this.program.Areas = new Array<AreaProgram>();
    this.user = JSON.parse(localStorage.getItem("user")) as User;
    this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
    this.congressos = JSON.parse(localStorage.getItem('congressos')) as Array<Congresso>;
    this.isCurrent = this.congresso ? this.congresso.Ano == configProvider.ANO_ATUAL : true || this.congresso.Liberado;

    this.activitiesFiltered = new Array<Activity>();
    this.lastRefreshDate = this.storageProvider.get('lastRefreshDate');
    this.salas = new Array<string>();
    this.horarios = new Array<string>();
    this.tipos = new Array<string>();
    this.palestrantes = new Array<string>();
    this.palestrantesSearch = new Array<string>();
    this.activities = new Array<Activity>();

    this.area = this.navParams.get("area") ? this.navParams.get("area") : this.area;
    this.filter.tipo = this.navParams.get("type") ? this.navParams.get("type") : this.filter.tipo;

    if(this.navParams.get("area")){
       this.filter.selected = true;
       this.paramArea = true;
    }

  }

  ionViewDidEnter() {
    this.user = JSON.parse(localStorage.getItem("user")) as User;
    this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
    this.loaded = false;
    var views = this.navCtrl.getViews();
    if (views.length == 1 || this.program.Areas.length == 0) {
      this.activitiesFiltered = new Array<Activity>();
      this.getProgram();
    }
    else this.loaded = true;
    this.getProgramacaoAtual();
    this.getActivitiesAssistidas();
    this.utilProvider.searchInFocus = false;
    this.utilProvider.searchTerm = "";
    let scroll = this.content.getScrollElement();
    scroll.style.overflowY = 'hidden';
  }

  getActivitiesInsc() {

    if (localStorage.getItem('atividadesInscritas'))
      this.activitiesInscIds = JSON.parse(localStorage.getItem('atividadesInscritas')) as number[];
    else
      this.activitiesInscIds = new Array<number>();
  }

  getActivitiesAssistidas() {

    if (localStorage.getItem('atividadesAssistidas'))
      this.atividadesAssistidasIds = JSON.parse(localStorage.getItem('atividadesAssistidas')) as number[];
    else
      this.atividadesAssistidasIds = new Array<number>();
  }

  getProgramNow() {
    let self = this;
    let connected = self.utilProvider.isConnected(true);
    if (connected) {
      self.program.Days = new Array<DayProgram>();
      self.program.Areas = new Array<AreaProgram>();
      this.activitiesFiltered = new Array<Activity>();
      this.loaded = false;
      let user = self.user ? self.user : new User();
      setTimeout(() => {
        self.congressoProvider.getCompleteProgramNoRealTime(self.congresso.Ano, user.Guid, user.TipoAssociacao, user.CategoriaId)
          .then(res => {
            if (res[0].Area) {
              self.program.Areas = res;
            }
            else {
              self.program.Days = res;
            }

            if (self.program.Days.length)
              self.days = self.program.Days[0].Dia.DiaData.substring(0, 2);
            if (self.program.Areas.length){
        
              self.area = this.navParams.get("area") ? this.navParams.get("area") : self.program.Areas[0].Area.Descricao;
            }

            self.setLocalStorage();
            self.loadStorageForUser();
            self.setFiltersValues();
            self.executeFilter();
            self.lastRefreshDate = new Date().toISOString();
            self.storageProvider.set('lastRefreshDate', self.lastRefreshDate);
            self.loaded = true;
          })
          .catch(response => {
            let err = response;
            if (err) {

              self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
            }
            this.loaded = true;
          });
      }, 0);
    }
    else {
      self.getFromStorage();
    }
  }

  getProgram() {
    let self = this;
    if (!self.lastRefreshDate || self.utilProvider.checkTimeToRefresh(self.lastRefreshDate)) {
      let connected = self.utilProvider.isConnected(true)
      if (connected) {
        let user = self.user ? self.user : new User();
        setTimeout(() => {
          self.congressoProvider.getCompleteProgramNoRealTime(self.congresso.Ano, user.Guid, user.TipoAssociacao, user.CategoriaId)
            .then(res => {
              if (res[0].Area) {
                self.program.Areas = res;
              }
              else {
                self.program.Days = res;
              }

              if (self.program.Days.length)
                self.days = self.program.Days[0].Dia.DiaData.substring(0, 2);
              if (self.program.Areas.length)
                self.area = this.navParams.get("area") ? this.navParams.get("area") : self.program.Areas[0].Area.Descricao;

              self.setLocalStorage();
              self.loadStorageForUser()

              self.setFiltersValues();
              self.executeFilter();
              self.lastRefreshDate = new Date().toISOString();
              self.storageProvider.set('lastRefreshDate', self.lastRefreshDate);
              self.loaded = true;
            })
            .catch(response => {
              let err = response;
              if (err) {

                self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
              }
              this.loaded = true;
            });
        }, 0);
      }
      else {
        self.getFromStorage();
      }
    }
    else {
      self.getProgramNow();
    }
  }

  getFromStorage() {
    setTimeout(() => {
      let self = this;
      self.program.Days = self.storageProvider.get('atividadesDia') as Array<DayProgram>;
      self.program.Areas = self.storageProvider.get('atividadesArea') as Array<AreaProgram>;
      self.days = self.program.Days[0].Dia.DiaData.substring(0, 2);
      self.area = this.navParams.get("area") ? this.navParams.get("area") : self.program.Areas[0].Area.Descricao; 

      let palestrantes = new Array<Lecturer>();
      if (this.program.Days.length) {
        this.program.Days.forEach((x) => {
          Array.prototype.push.apply(palestrantes, x.Palestrantes);
        });
      }
      else {
        this.program.Areas.forEach((x) => {
          Array.prototype.push.apply(palestrantes, x.Palestrantes);
        });
      }

      localStorage.setItem('palestrantes', palestrantes ? JSON.stringify(palestrantes.filter((thing, index, self) => self.findIndex((t) => { return t.Nome === thing.Nome; }) === index).sort()) : '');

      self.setFiltersValues();
      self.executeFilter();
      this.loaded = true;
    });
  }

  loadStorageForUser() {
    if (localStorage.getItem('user')) {
      let user = JSON.parse(localStorage.getItem('user')) as User;
      let self = this;
      let connected = self.utilProvider.isConnected(false)
      if (connected) {
        self.userProvider.getAtividadesInscritasIdsUsuario(user.Guid, self.congressos[0].Ano)
          .then(d => {

            if (d)
              localStorage.setItem('atividadesInscritas', JSON.stringify(d));
            this.getActivitiesInsc();
          });

        self.userProvider.getPalestrantesFavoritos(user.Guid, self.congressos[0].Ano)
          .then(r => {

            if (r)
              localStorage.setItem('palestrantesFavoritos', JSON.stringify(r.resposta.retorno))
          });

        self.userProvider.getAtividadesAssistidasIdsUsuario(user.Guid, self.congressos[0].Ano)
          .then(d => {

            if (d)
              localStorage.setItem('atividadesAssistidas', JSON.stringify(d));
            this.getActivitiesAssistidas();
          });
      }
    }
  }

  setLocalStorage() {
    let self = this;

    this.storageProvider.insert('atividadesDia', this.program.Days ? JSON.stringify(this.program.Days) : '');
    //localStorage.setItem('atividadesDia', this.program.Days ? JSON.stringify(this.program.Days) : '');

    localStorage.setItem('atividadesArea', this.program.Areas ? JSON.stringify(this.program.Areas) : '');

    let palestrantes = new Array<Lecturer>();
    this.program.Days.forEach((x) => {
      Array.prototype.push.apply(palestrantes, x.Palestrantes);
    });

    this.program.Areas.forEach((x) => {
      Array.prototype.push.apply(palestrantes, x.Palestrantes);
    });

    localStorage.setItem('palestrantes', palestrantes ? JSON.stringify(palestrantes.filter((thing, index, self) => self.findIndex((t) => { return t.Nome === thing.Nome; }) === index).sort()) : '');

    if (self.congresso.Ano == self.configProvider.ANO_ATUAL)
      localStorage.setItem('programacaoAtual', JSON.stringify(self.program.Days.length ? self.program.Days : self.program.Areas))
  }

  getProgramacaoAtual() {

    let self = this;

    if (!self.lastRefreshDate || self.utilProvider.checkTimeToRefresh(self.lastRefreshDate)) {
      let connected = self.utilProvider.isConnected(false);
      if (connected) {
        let user = new User();

        //self.utilProvider.loadingShow()

        self.congressoProvider.getCompleteProgramNoRealTime(self.congressos[0].Ano, user.Guid, user.TipoAssociacao, user.CategoriaId)
          .then(res => {

            res.forEach(x => {
              Array.prototype.push.apply(this.activities, x.Atividades);
            });

            self.storageProvider.set('programacaoAtual', res);

            if (self.congresso.Ano == self.congressos[0].Ano) {
              if (self.program.Days.length)
                self.storageProvider.set('atividadesDia', res)
              if (self.program.Areas.length)
                self.storageProvider.set('atividadesArea', res)

              let lastRefreshDate = new Date().toISOString();
              self.storageProvider.set('lastRefreshDate', lastRefreshDate);
            }
            //self.utilProvider.loadingHide();
          })
          .catch(response => {
            if (connected) {
              let err = response;
              if (err) {

                self.alert.showAlert('Erro', 'Ocorreu um erro interno ao tentar recuperar a programação atual.');
              }
            }
            //self.utilProvider.loadingHide();

          });
      }
    }
  }

  setFiltersValues() {
    let self = this;

    //Filtros por Área
    if (self.program.Areas.length) {

      self.program.Areas.forEach((x) => {
        Array.prototype.push.apply(self.activitiesFiltered, x.Atividades as Array<Activity>);
      });

      self.program.Areas.forEach((x) => {
        let tips = x.Atividades.filter(a => a.AreaAbrangencia == x.Area.Descricao)
        Array.prototype.push.apply(self.tipos, tips.map((a) => (a.Sigla)));
      });

      self.program.Areas.forEach((x) => {
        let pls = x.Palestrantes;
        Array.prototype.push.apply(self.palestrantes, pls.map((p) => (p.Nome)));
      });

    }

    if (self.program.Days.length) {

      self.program.Days.forEach((x) => {
        Array.prototype.push.apply(self.activitiesFiltered, x.Atividades as Array<Activity>);
      });

      self.program.Days.forEach((x) => {
        let sls = x.Atividades.filter(a => a.DiaData == x.Dia.DiaData);
        Array.prototype.push.apply(self.salas, sls.map((a) => (a.SiglaSala)));
      });

      self.program.Days.forEach((x) => {
        let ds = x.Atividades.filter(a => a.DiaData == x.Dia.DiaData)
        Array.prototype.push.apply(self.horarios, ds.map((a) => (a.HoraInicioAtividade.replace(':', 'h'))));
      });

      self.program.Days.forEach((x) => {
        let tips = x.Atividades.filter(a => a.DiaData == x.Dia.DiaData)
        Array.prototype.push.apply(self.tipos, tips.map((a) => (a.Sigla)));
      });

      self.program.Days.forEach((x) => {
        let pls = x.Palestrantes;
        Array.prototype.push.apply(self.palestrantes, pls.map((p) => (p.Nome)));
      });
    }

    self.salas = self.salas.filter((value, index, self) => self.indexOf(value) === index).sort();
    self.horarios = self.horarios.filter((value, index, self) => self.indexOf(value) === index).sort();
    self.tipos = self.tipos.filter((value, index, self) => self.indexOf(value) === index).sort();
    self.palestrantes = self.palestrantes.filter((value, index, self) => self.indexOf(value) === index).sort();
    self.palestrantesSearch = self.palestrantes;
  }

  showFilter() {

    this.filter.selected = !this.filter.selected;
    if (!this.filter.selected) {

      this.filter = new Filter();
      this.filter.palestrante = '';
      this.filter.selected = false;
      localStorage.removeItem('filter');

      this.program.Days.forEach((x) => {
        x.Atividades = this.activitiesFiltered.filter(a => a.DiaData == x.Dia.DiaData);
      });

      this.program.Areas.forEach((x) => {
        x.Atividades = this.activitiesFiltered.filter(a => a.AreaAbrangencia == x.Area.Descricao);
      });

    }
    else {
      this.filter.selected = true;
      localStorage.setItem('filter', JSON.stringify(this.filter));
      this.radioSelected = false;
    }
  }


  executeFilter() {

    let self = this;

    //Filtro por Área
    if (this.program.Areas.length) {

      this.program.Areas.forEach((x) => {
        x.Atividades = self.activitiesFiltered.filter(a => a.AreaAbrangencia == x.Area.Descricao);
      });

      if (this.radioSelected) {
        this.program.Areas.forEach((x) => {
          x.Atividades = x.Atividades.filter(a => (a.VagasTotal - a.VagasOcupadas) > 0);
        });
      }

      if (this.filter.sala) {
        this.program.Areas.forEach((x) => {
          x.Atividades = x.Atividades.filter(a => (a.SiglaSala == self.filter.sala));
        });
      }

      if (this.filter.horario) {
        this.program.Areas.forEach((x) => {
          x.Atividades = x.Atividades.filter(a => a.HoraInicioAtividade.replace(':', 'h') >= self.filter.horario);
        });
      }

      if (this.filter.tipo) {
        this.program.Areas.forEach((x) => {
          x.Atividades = x.Atividades.filter(a => a.Sigla == self.filter.tipo);
        });
      }

      if (this.filter.palestrante) {

        this.program.Areas.forEach((x) => {
          x.Atividades = x.Atividades.filter((a) => a.AtividadesCadastro.filter(c => c.Palestrantes.length > 0
            && this.utilProvider.prepareSearch(c.Palestrantes[0].Nomes.toLowerCase()).indexOf(this.utilProvider.prepareSearch(self.filter.palestrante.toLowerCase())) > -1).length > 0);
          //x.Atividades = x.Atividades.filter((a) => a.Palestrantes && this.utilProvider.prepareSearch(a.Palestrantes[0].Nomes.toLowerCase()).indexOf(self.filter.palestrante.toLowerCase()) > -1);
        });
      }

    }

    if (this.program.Days.length) {

      this.program.Days.forEach((x) => {
        x.Atividades = self.activitiesFiltered.filter(a => a.DiaData == x.Dia.DiaData);
      });


      if (this.radioSelected) {
        this.program.Days.forEach((x) => {
          x.Atividades = x.Atividades.filter(a => (a.VagasTotal - a.VagasOcupadas) > 0);
        });
      }

      if (this.filter.sala) {
        this.program.Days.forEach((x) => {
          x.Atividades = x.Atividades.filter(a => (a.SiglaSala == self.filter.sala));
        });
      }

      if (this.filter.horario) {
        this.program.Days.forEach((x) => {
          x.Atividades = x.Atividades.filter(a => a.HoraInicioAtividade.replace(':', 'h') >= self.filter.horario);
        });
      }

      if (this.filter.tipo) {
        this.program.Days.forEach((x) => {
          x.Atividades = x.Atividades.filter(a => a.Sigla == self.filter.tipo);
        });
      }

      if (this.filter.palestrante) {

        this.program.Days.forEach((x) => {
          x.Atividades = x.Atividades.filter((a) => a.AtividadesCadastro.filter(c => c.Palestrantes.length > 0
            && this.utilProvider.prepareSearch(c.Palestrantes[0].Nomes.toLowerCase()).indexOf(this.utilProvider.prepareSearch(self.filter.palestrante.toLowerCase())) > -1).length > 0);
          //x.Atividades = x.Atividades.filter((a) => a.Palestrantes && this.utilProvider.prepareSearch(a.Palestrantes[0].Nomes.toLowerCase()).indexOf(self.filter.palestrante.toLowerCase()) > -1);
        });
      }
    }

    localStorage.setItem('filter', JSON.stringify(this.filter));
  }

  clearSala() {
    this.filter.sala = '';
    localStorage.setItem('filter', JSON.stringify(this.filter));
    this.executeFilter();
  }

  clearTipo() {
    this.filter.tipo = '';
    localStorage.setItem('filter', JSON.stringify(this.filter));
    this.executeFilter();
  }

  clearHorario() {
    this.filter.horario = '';
    localStorage.setItem('filter', JSON.stringify(this.filter));
    this.executeFilter();
  }

  getPalestrantesFilter(ev: any) {

    this.palestrantesSearch = this.palestrantes;

    let val = ev.target.value;

    if (val && val.trim() != '') {

      this.palestrantesSearch = this.palestrantesSearch.filter((item) => {
        return (item.toLowerCase().indexOf(val.toLowerCase()) > -1);
      }).slice(0, 5);

      this.showList = true;
      if (ev.target)
        this.renderer.invokeElementMethod(ev.target, 'blur');
    } else {
      this.showList = false;
    }

    this.executeFilter();
  }

  setPalestrante(p: string) {
    this.filter.palestrante = p;
    this.showList = false;
    this.executeFilter();
  }

  checkVagas() {
    this.radioSelected = !this.radioSelected;
    this.executeFilter();
  }

  openInscriptionPage(activityId: number) {
    let activity = new Activity();

    activity = this.activitiesFiltered.filter(a => a.AtividadeId == activityId)[0] as Activity;
    activity.Palestrantes = activity.AtividadesCadastro.map(p => p.Palestrantes[0]).filter(x => x);
    this.navCtrl.push(AtividadePage, {
      id: activityId,
      activity: activity,
      doBackload: false
    });
  }

  confirmPresence(participar: boolean, activity: Activity) {
    let self = this;
    if (self.utilProvider.isConnected(true) && self.auth.isAuthorized()) {
      self.alert.showConfirm((participar ? 'Confirmação' : 'Cancelameto'), 'Deseja ' + (participar ? 'confirmar' : 'cancelar') + ' sua inscrição na atividade: <strong>' + activity.TemaDaAtividade + '</strong>?', 'Sim', 'Não', () => {
        self.utilProvider.loadingShow();
        self.congressoProvider.confirmarPresencaAtividade(activity.AtividadeId, participar)
          .then(res => {
            self.utilProvider.loadingHide();
            res = JSON.parse(res);
            if (res.resposta.codigo == 0) {
              let activities = self.calendarProvider.getAllActivities();
              let atividade = activities.filter(x => x.AtividadeId == activity.AtividadeId)[0] as Activity;

              if (participar) {
                activity.InscritoNaAtividade = true;
                self.activitiesInscIds.push(activity.AtividadeId);
                localStorage.setItem('atividadesInscritas', JSON.stringify(self.activitiesInscIds));

                //if (+localStorage.getItem('config') > 0) {
                //    self.calendarProvider.create('', '').then((c) => {
                //        c.addActivity(atividade, true);
                //    });
                //}

                activity.VagasOcupadas++;

                self.alert.showAlert('Sucesso', 'Inscrição confirmada!');
              }
              else {
                activity.InscritoNaAtividade = false;
                self.activitiesInscIds = self.activitiesInscIds.filter(x => x != activity.AtividadeId);
                localStorage.setItem('atividadesInscritas', JSON.stringify(self.activitiesInscIds));

                //if (+localStorage.getItem('config') > 0) {

                //    self.calendarProvider.create('', '').then((c) => {
                //        c.removeActivity(atividade, true);
                //    });
                //}

                activity.VagasOcupadas--;
                self.alert.showAlert('Sucesso', 'Inscrição cancelada!');
              }
            }
            else if (res.resposta.codigo == -1 && res.resposta.retorno.error)
              self.alert.showAlert('Atenção', res.resposta.retorno.error);
            else if (res.resposta.codigo == -1 && res.resposta.retorno.Erro)
              self.alert.showConfirm('Atenção', res.resposta.retorno.Erro.replace('<br><br>', ' '), 'Sim', 'Não', self.goToSgunInscription);
            else if (res.resposta.retorno.Conflito) {
              let conflitText = 'Você já reservou sua vaga para: \n\n"<b>' + res.resposta.retorno.SiglaAtividade + ' ' + res.resposta.retorno.OrdemAtividade + ' - ' + res.resposta.retorno.Descritivo +
                '</b>" que ocorre na <b>' + res.resposta.retorno.Sigla + ' das ' + res.resposta.retorno.HoraInicio + ' às ' + res.resposta.retorno.HoraTermino +
                '</b>.\n\nDeseja substituir por:\n\n<b>' + '"' + res.resposta.retorno.AtividadeCadastrar.SiglaAtividade + ' ' + res.resposta.retorno.AtividadeCadastrar.OrdemAtividade + ' - ' + res.resposta.retorno.AtividadeCadastrar.Descritivo + '</b>" que ocorre na <b>' +
                res.resposta.retorno.AtividadeCadastrar.Sigla + ' das ' + res.resposta.retorno.AtividadeCadastrar.HoraInicio + ' às ' + res.resposta.retorno.AtividadeCadastrar.HoraTermino + '</b>';
              //Substituir Presença

              self.alert.showConfirm('Atenção', conflitText, 'Sim', 'Não', () => {
                self.replacePresence(activity.AtividadeId, res.resposta.retorno.AtividadeId, self.user.Guid, self.user.Login, self.user.TipoAssociacaoId, self.user.CategoriaId);
              });
            }
            else if (res.resposta.retorno[0].error) {
              self.alert.showAlert('Atenção', res.resposta.retorno[0].error);
              if (res.resposta.retorno[0].error === 'Não existem vagas para esta atividade!')
                activity.VagasOcupadas = activity.VagasTotal;
            }
          })
          .catch(response => {
            let err = response;
            if (err) {
              self.utilProvider.loadingHide();

              self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
            }
          });
      });
    }
  }

  replacePresence(addActivityId: number, removeActivityId: number, userGuid: string, userLogin: string, associationId: number, categoryId: number) {
    let self = this;
    if (self.utilProvider.isConnected(true) && self.auth.isAuthorized()) {
      self.utilProvider.loadingShow();
      self.congressoProvider.substituirPresencaAtividade(addActivityId, removeActivityId, userGuid, userLogin, associationId, categoryId)
        .then(res => {
          res = JSON.parse(res);
          if (res.resposta.codigo == 0) {
            let index = self.activitiesInscIds.indexOf(removeActivityId);

            if (index != -1)
              self.activitiesInscIds.splice(index, 1);

            self.activitiesInscIds.push(addActivityId);
            localStorage.setItem('atividadesInscritas', JSON.stringify(self.activitiesInscIds));

            if (+localStorage.getItem('config') > 0) {
              let activities = self.calendarProvider.getAllActivities();
              let atividadeAntiga = activities.filter(x => x.AtividadeId == removeActivityId)[0] as Activity;
              let atividadeNova = activities.filter(x => x.AtividadeId == addActivityId)[0] as Activity;

              //self.calendarProvider.create('', '').then((c) => {
              //    c.removeActivity(atividadeAntiga, false);
              //    c.addActivity(atividadeNova, true);
              //});
            }

            self.activitiesFiltered.filter(x => x.AtividadeId == removeActivityId)[0].VagasOcupadas--;
            self.activitiesFiltered.filter(x => x.AtividadeId == addActivityId)[0].VagasOcupadas++;

            self.alert.showAlert('Sucesso', 'Subtituição confirmada!');
          } else
            self.alert.showAlert('Erro', res.resposta.retorno[0].error);

          self.utilProvider.loadingHide();
        })
        .catch(response => {
          let err = response;
          if (err) {
            self.utilProvider.loadingHide();

            self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
          }
        });
    }
  }

  isInscrito(a: Activity) {

    return (localStorage.getItem('atividadesInscritas') ? JSON.parse(localStorage.getItem('atividadesInscritas')).some(x => x == a.AtividadeId) : false);
  }

  goToSgunInscription() {
    window.open('http://sgun.sogesp.org.br/evento/inscricao', "_blank", "location=yes,toolbar=yes,hidden=no");
  }

  getHeightFilter() {
    return this.utilProvider.getPlatform() == 'ios' ? 'h-105' : 'h-105';
  }

  getTop() {
    return this.utilProvider.getPlatform() == 'ios' && !this.utilProvider.isTablet() ? '149px' : 
    this.utilProvider.getPlatform() == 'android' ? '149px' : '197px';
  }


  getHeightScroll() {
    return this.filter.selected ? 'h-filter' : 'h-normal';
  }

  hasResult(d: any) {

    return (d.Atividades && d.Atividades.length)
  }
  180
  getDay(d: string) {
    this.content.scrollToTop();
    return this.utilProvider.getDay(d);
  }

  showVagas(a: Activity) {
    return (a.VagasTotal - a.VagasOcupadas <= 50 && a.VagasTotal - a.VagasOcupadas > 0);
  }

  canRegister(a: Activity) {
    return this.isCurrent &&
      a.Sigla != this.LM &&
      a.Sigla != this.SP &&
      a.Sigla != this.ABT &&
      a.Sigla != this.ECR;
  }

  getPercentualAssistido(a: Activity): Number {
    let videos = a.AtividadesCadastro.filter(x => x.UrlVideo);
    let assistidas = 0;

    this.atividadesAssistidasIds.forEach(e => {
      if (a.AtividadesCadastro.filter(a => a.UrlVideo).some(x => x.Id == e))
        assistidas++;
    });

    return videos.length > 0 ? Number(((assistidas * 100) / videos.length).toFixed(0)) : 0;

  }
}



// WEBPACK FOOTER //
// ./src/pages/aulas/aulas.ts